// extracted by mini-css-extract-plugin
export default {"container":"kJ4CP0zV","input":"Azc9zqbC","icon":"t91CCbsi"};